import { jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { dropdownMenuContext } from "./dropdown-menu-context.es.js";
import { DropdownMenuSeparatorComponent } from "./dropdown-menu-separator.styles.es.js";
const DropdownMenuSeparator = () => {
  const { spacing } = useContext(dropdownMenuContext);
  return /* @__PURE__ */ jsx(DropdownMenuSeparatorComponent, { spacing });
};
export {
  DropdownMenuSeparator
};
